import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterHundred extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder textTitle="Blockchain:" text="A digital decentralized, secure and transparent public ledger of all cryptocurrency transactions." />
        <TextHolder textTitle="Community builder:" text="A member of the tech space responsible for building, scaling, or coordinating the startup ecosystem. Examples include coworking spaces, incubators, and accelerators." />
        <TextHolder textTitle="Cryptocurrency:" text="A digital currency in which encryption (“cryptography”) techniques are used to regulate the generation of units of currency and verify the transfer of funds, allowing it to operate independently of a central bank" />
        <TextHolder textTitle="Frontier tech:" text="Areas of advanced tech that have significant R&D focus but that have not yet reached widespread commercial adoption. Current examples include: artificial intelligence/machine learning, blockchain and cryptocurrency." />
        <TextHolder textTitle="ICO:" text="Stands for “Initial Coin Offering.” A form of crowdfunding using cryptocurrencies, wherein a startup offers a quantity of a new cryptocurrency to investors, in the form of financial devices called “tokens,” in exchange for legal tender or other cryptocurrency.  Tokens are expected to convert to functional units of currency once the ICO’s funding goal is met and the project launches." />
        <TextHolder textTitle="SEA turtles:" text="Startup and tech professionals who were born in SEA and spent a significant period abroad (usually for education) before returning to the region." />
        <TextHolder textTitle="Unicorn:" text="A startup that has achieved a valuation of $1 billion or more." />


        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/100.js